import script from "./WelcomeCards.vue?vue&type=script&lang=ts&setup=true"
export * from "./WelcomeCards.vue?vue&type=script&lang=ts&setup=true"

import "./WelcomeCards.vue?vue&type=style&index=0&id=0a2366f4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2366f4"]])

export default __exports__